import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { useIncome } from "../../../contexts/IncomeContext";
import { useNavigate } from "react-router-dom";

interface Props {
  incomeId: string;
}

const DeleteIncomeButton: React.FC<Props> = ({ incomeId }) => {
  const { deleteIncomeById } = useIncome();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);

  const handleSubmit = async () => {
    setIsDeleteing(true);
    try {
      await deleteIncomeById(incomeId);
      setIsOpen(false);
      navigate("/incomes");
    } catch (error) {
      console.error("Error deleting income:", error);
      alert("Failed to delete income. Please try again later.");
    }
    setIsDeleteing(false);
  };

  return (
    <>
      <Button type="button" color="red" onClick={() => setIsOpen(true)}>
        Delete
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Delete Income</AlertTitle>
        <AlertDescription>
          Are you sure you want to delete this income? This action cannot be
          undone.
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isDeleteing}>
            Cancel
          </Button>
          <Button color="red" onClick={handleSubmit} disabled={isDeleteing}>
            Delete
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default DeleteIncomeButton;
